export const concatUrl = (url: string, searchParams: URLSearchParams | Record<string, string>): string => {
  const [pathname, search] = url.split('?')
  const existingParams = new URLSearchParams(search)
  const newParams = new URLSearchParams(searchParams)
  const params = new URLSearchParams([...existingParams, ...newParams])
  return params.size > 0 ? `${pathname}?${params}` : pathname
}
